module.exports = __webpack_public_path__ + "img/digital-illustrations-banner.9bd93f1a.jpg";